import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { withRouter } from 'react-router-dom';
import { compose, lifecycle } from 'recompose';

import App, { AppProps } from './App';
import { RootState } from '@store/reducers';
import { getAuthUser, getUserIsLogged } from '@store/auth/auth.selector';
import { LoadersNames, requireLogin } from '@store/ui/ui.actions';
import { getToken } from '../frontendUtils/local-storage';
import { getCurrentUser } from '@store/auth/auth.actions';
import { getLoader } from '@store/ui/ui.selector';

interface AppContainerProps extends AppProps {}

interface AppContainerPrivateProps extends AppContainerProps {
  currentUserRequest: typeof getCurrentUser.started;
}

const mapStateToProps = (state: RootState) => ({
  notifications: state.notifications,
  user: getAuthUser(state),
  isLogged: getUserIsLogged(state),
  isLoading: getLoader(LoadersNames.loggingIn)(state),
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      requireLogin,
      currentUserRequest: getCurrentUser.started,
    },
    dispatch,
  );

export default withRouter(
  compose<{}, {}>(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    ),
    lifecycle<AppContainerPrivateProps, AppContainerProps>({
      componentDidMount() {
        if (!this.props.isLogged && !this.props.isLoading) {
          const token = getToken();
          if (token) {
            this.props.currentUserRequest({});
          }
        }
      },
    }),
  )(App),
);
